import {Routes} from '@angular/router'
import {LoginComponent} from './ui/login/login.component'

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'detail/:id',
        loadChildren: () => import('./ui/detail/detail-routes')
      },
      {
        path: 'list',
        loadComponent: () => import('./ui/list/list-resources.component').then(c => c.ListResourcesComponent)
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'login'
      }
    ]
  }
]
